var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// $FlowFixMe
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
import { cyLabelFormater } from 'app/libs/helpers/cyTools.js';
import { Accordion, AccordionDetails, AccordionSummary, styled, } from '@mui/material';
const MUIAccordionSummary = styled((props) => _jsx(AccordionSummary, Object.assign({}, props)))(({ theme }) => ({
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper': {
        transform: 'rotate(90deg)',
        '& .Mui-expanded': {
            transform: 'rotate(180deg)',
        },
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(2),
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
        marginLeft: theme.spacing(2),
    },
}));
const MUIAccordion = styled((props) => _jsx(Accordion, Object.assign({ elevation: 0, square: true }, props)))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    fontSize: theme.typography.pxToRem(15),
    '& .MuiAccordionSummary-root': {
        maxHeight: 48,
        minHeight: 48,
        padding: '0 20px',
        '&.Mui-expanded': {
            maxHeight: 48,
            minHeight: 48,
            padding: '0 20px',
        },
    },
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));
const MUIAccordionDetails = styled((props) => _jsx(AccordionDetails, Object.assign({}, props)))(({ theme }) => ({
    borderTop: '1px solid lightgrey',
    fontWeight: 'initial',
    padding: theme.spacing(2),
    backgroundColor: 'rgba(0,0,0,0.04)',
}));
function ExpansionPanel(props) {
    const { classes, title, titleProps, children, expandIcon, timeout, style, leftContent, centerContent, rightContent, defaultExpanded, disableExpansionPanel, expanded: _expanded, autoload, icon, dataCy } = props, rest = __rest(props, ["classes", "title", "titleProps", "children", "expandIcon", "timeout", "style", "leftContent", "centerContent", "rightContent", "defaultExpanded", "disableExpansionPanel", "expanded", "autoload", "icon", "dataCy"]);
    const [open, setOpen] = useState(defaultExpanded || _expanded || false);
    if (disableExpansionPanel)
        return children || null;
    const onChange = (event, expanded) => {
        setOpen(expanded);
    };
    return (_jsxs(MUIAccordion, Object.assign({ style: Object.assign(Object.assign({}, style), { fontWeight: 'bold', boxShadow: '0px 1px 0px 0px rgba(93, 93, 93, 0.56)' }), expanded: _expanded || open, "data-testid": cyLabelFormater('expansion-panel', dataCy || ''), onChange: onChange }, rest, { children: [_jsx(MUIAccordionSummary, { expandIcon: expandIcon || _jsx(FontIcon, { style: { fontSize: 14 }, icon: "fas-chevron-up" }), children: _jsxs("div", { className: "flex row noWrap fullWidth", style: { paddingRight: 0 }, children: [leftContent ? _jsx("div", { className: "flex start", children: leftContent }) : null, _jsxs("div", Object.assign({ className: `flex flex1 alignCenter textNoWrap ${(classes === null || classes === void 0 ? void 0 : classes.heading) || ''}` }, titleProps, { children: [icon ? (_jsx("span", { style: { marginRight: '10px', color: 'rgb(178, 185, 199)' }, children: _jsx(FontAwesomeIcon, { icon: icon }) })) : null, _jsx("span", { children: title })] })), centerContent ? _jsx("div", { className: "flex flex1 alignCenter center", children: centerContent }) : null, rightContent ? _jsx("div", { className: "flex flex1 alignCenter end", children: rightContent }) : null] }) }), _jsx(MUIAccordionDetails, { children: open || autoload ? children : _jsx("div", {}) })] })));
}
export default ExpansionPanel;
